import { useEffect } from "react";
import { useSession } from "@supabase/auth-helpers-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createBrowserRouter } from "react-router-dom";

import { AuthProvider } from "./hooks/AuthContext";
import { MessageProvider } from "./hooks/MessageContext";
import { PageContextProvider } from "./hooks/PageContext";
import { ToastProvider } from "./hooks/ToastContext";
import { AlertsContextWrapper } from "./containers/AlertsContextWrapper";
import { UserContentContextWrapper } from "./hooks/UserContentContextWrapper";
import { EventStreamingWrapper } from "./hooks/useMessageStream";
import { initMixpanel, trackPageView } from "./mixpanel";
import createRoutes from "./routes";

export const queryClient = new QueryClient();

function App() {
  const session = useSession();

  // Create router with routes that depend on session state
  const router = createBrowserRouter(createRoutes(session));

  useEffect(() => {
    initMixpanel();
    trackPageView(router.state.location.pathname);
    const unsubscribe = router.subscribe((state) => {
      trackPageView(state.location.pathname);
    });
    return unsubscribe;
  }, [router]);

  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AlertsContextWrapper>
          <AuthProvider>
            <PageContextProvider>
              <UserContentContextWrapper>
                <EventStreamingWrapper>
                  <MessageProvider>
                    <RouterProvider router={router} />
                  </MessageProvider>
                </EventStreamingWrapper>
              </UserContentContextWrapper>
            </PageContextProvider>
          </AuthProvider>
        </AlertsContextWrapper>
      </ToastProvider>
    </QueryClientProvider>
  );
}

export default App;
